import "./PujaSubcategoriesView.scss";
import { Box, Grid, Typography, Button, Stack } from "@mui/material";  
import PujaListCard from "../../components/card/Puja/PujaListCard";
import ShareLink from "../../components/sharelink/sharelink";
import { useEffect, useState } from "react";
import { getMaxAllowedMember } from "../../utils/HelperFunctions";
import ImageView from "../../components/ImageView/ImageView";
import MasonryGrid from "../../components/MasonryGrid/MasonryGrid";

function PujaSubCategoriesView(props: any) {
  const subCategoryDetails = props.subCategoryDetails;

  const [urlToShare, setUrlToShare] = useState<string>("");

  useEffect(() => {
    const hostname =
      window.location.hostname === "localhost"
        ? "http://localhost:3000"
        : "https://" + window.location.hostname;
    setUrlToShare(
      `${hostname}/pagelink?subcategory=${props?.subCategoryDetails?.subCategoryId}`
    );
  }, [props.subCategoryDetails]);

  return (
    <Box className="pageContainer pujaSubCategory">
      <Box className="templeBlock">
        <Grid container spacing={1}>
          <Grid item xs={12} md={2} lg={2} xl={2} className="pagehdLeftBlock">
            {/* <LeftAddressCard
              header={props.TDTexts.CURRENTADDRESS}
              address={
                props.userAddressList && props.userAddressList.length > 0
                  ? props.userAddressList[0].formatted_address
                  : ""
              }
              footerButton="Edit or add an address"
            /> */}
          </Grid>
          <Grid item xs={12} md={8} lg={8} xl={8}>
            <Box className="pujaSubCategoryCenterBlock">
              {/* <Box
                className="promoPujaBanner"
                style={{
                  backgroundImage: `url(${props.subCategoryDetails?.url})`,
                }}
              ></Box> */}
              <Box className="catgIndivisualDetails">
                <Box className="bannerImgBlock">
                  {props.subCategoryDetails?.url && (
                    <ImageView
                      src={props.subCategoryDetails?.url}
                      alt={"puja banner"}
                    />
                  )}
                </Box>
                <Box className="categoryDescription">
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    className="desTopTitle"
                  >
                    <Typography className="categoryTitle">
                      {subCategoryDetails?.name}
                    </Typography>
                    <Box className="shareIcon">
                      <ShareLink urlToShare={urlToShare} type="Puja Subcategory"></ShareLink>
                    </Box>
                  </Stack>
                  <Typography>{subCategoryDetails?.description}</Typography>
                </Box>
              </Box>

              <Box className="categoryPujaTitle">
                <Typography variant="h6">Offering Pujas</Typography>
              </Box>

              <Box className="templeCenterBlock">
                {props.allPujaList && props.allPujaList.length > 0 ? (
                  <MasonryGrid
                    items={props.allPujaList}
                    renderItem={(item, id) => (
                      <PujaListCard
                        key={id}
                        pujaData={item}
                        pujaName={item.pujaDetails.pujaName}
                        templeProfilePic={item.pujaDetails.pujaBg?.uri}
                        description={item.pujaDetails.description}
                        benefits={item.pujaDetails.benefits}
                        acctualPrice={item.pujaDetails.acctualPrice}
                        onClickAddPuja={props.onClickAddPuja}
                        temple={item.personalInfo}
                        devoteeCount={getMaxAllowedMember(
                          item?.pujaDetails?.multiplePujaDetails?.length
                            ? item?.pujaDetails?.multiplePujaDetails
                            : []
                        )}
                        benefitList={item?.pujaDetails?.benefitList}
                        isPujaDisable={item?.pujaDetails?.isPujaDisable}
                        leftSideTextOverlay={item?.pujaDetails?.leftSideTextOverlay}
                        rightSideTextOverlay={item?.pujaDetails?.rightSideTextOverlay}
                        overlayCss={item?.overlayCss ?? null}
                      />
                    )}
                  />
                ) : (
                  <Box className="noPujaItem">
                    <Typography>Puja not avaliable at this moment</Typography>
                  </Box>
                )}
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} md={2} lg={2} xl={2} className="pagehdRightBlock">
            {/* <RightBlockCard /> */}
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default PujaSubCategoriesView;
